import { useFeatureFlag } from '@zealot/ui/hooks/useFeatureFlag';
import { useCallback, useRef } from 'react';
import { getBrandCodeByBrandName, readBrandByLabel } from '@/pages/api/brand-missions';
import logger from '@/utils/logger';

// why: the ref lets sign-in effects started before PostHog loads read the current flag.
export const useBrandCodeLookup = () => {
  const { isEnabled } = useFeatureFlag('use_v2_brand_code_lookup');
  const isEnabledRef = useRef(isEnabled);
  isEnabledRef.current = isEnabled;

  return useCallback(async (brandLabel: string, accessToken: string | null): Promise<string | undefined> => {
    if (isEnabledRef.current) {
      if (!brandLabel) return undefined;
      const { brand } = await readBrandByLabel(brandLabel).catch((error: unknown) => {
        logger.error(error);
        return { brand: undefined };
      });
      return brand?.code || undefined;
    }
    const rows: { body?: Array<{ code?: string }> } = await getBrandCodeByBrandName(brandLabel, accessToken);
    return rows.body?.[0]?.code;
  }, []);
};
